import React, { ComponentProps } from 'react';
import { TableSelectRow as CarbonTableSelectRow } from '@carbon/react';

export type TableSelectRowProps = ComponentProps<typeof CarbonTableSelectRow>;

export const TableSelectRow = (props: TableSelectRowProps) => (
  <CarbonTableSelectRow {...props} />
);

TableSelectRow.displayName = 'TableSelectRow';
